import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_label = _resolveComponent("ps-label")!

  return (_openBlock(), _createBlock(_component_ps_label, { class: "select-none inline-flex items-center" }, {
    default: _withCtx(() => [
      _createElementVNode("input", {
        type: "checkbox",
        class: "form-checkbox me-2 checked:bg-primary-500 dark:bg-primaryDark-accent",
        id: $props.title,
        checked: $props.value,
        onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleInput($event.target.checked)))
      }, null, 40, _hoisted_1),
      _createTextVNode(" " + _toDisplayString($props.title), 1)
    ]),
    _: 1
  }))
}